module.exports = __webpack_public_path__ + "img/jaws-streaming.e37bc3ca.png";